import WebLayout from "../../components/WebLayout.jsx";
import Landing from "../../components/landing/Landing";
import { AboutUs, MissionVision, Team, LogoSlider } from "./index.js";

import axios from "axios";
import { baseUrl, getAbout } from "../../utils/apiData.js";
import { Fragment, useEffect, useState } from "react";
import Loader from "../../components/loader/Loader.jsx";

const About = () => {
  const [loader, setLoader] = useState(false);
  const [pageData, setPageData] = useState({});
  const [blogs, setBlogs] = useState([]);
  const [clients, setClients] = useState([]);
  const [team, setTeam] = useState([]);

  const getAboutApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getAbout}`);

      if (res?.data?.success) {
        setPageData(res?.data?.data?.aboutpage);
        setBlogs(res?.data?.data?.blogs);
        setClients(res?.data?.data?.client);
        setTeam(res?.data?.data?.team);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getAboutApi();
  }, []);

  return (
    <WebLayout>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <Landing title="About Us" from="Home" page="About Us" />
          <AboutUs
            tagTitle={pageData?.about_us_title}
            title={pageData?.about_us_heading}
            des={pageData?.about_us_description}
            img={pageData?.about_us_image}
            btnName=""
            contentLeft={true}
            classList="p_t p_b"
          />
          <AboutUs
            tagTitle=""
            title=""
            des={pageData?.about_us_description_2}
            img={pageData?.about_us_image_2}
            btnName="Contact Us"
            contentLeft={false}
            classList="p_b"
          />
          
          
          <MissionVision data={pageData} />
          <Team dataList={team} />
     
        </Fragment>
      )}
    </WebLayout>
  );
};

export default About;
